import React from 'react';
import ResetIcon from '@mui/icons-material/RestartAlt';
import { Stack } from '@mui/material';

import {
  INDETERMINATE,
  IndeterminateValue,
  isIndeterminate,
  MaterialPropertyValuePair,
  PropertySelectField,
  TooltipIconButton,
} from '@paragon/client-tools';
import { TrussEnvelopeBevelCut, TrussEnvelopeBevelCutType } from '@paragon/contract-library';
import { AngleField } from '@paragon/material';

import { UserSpecifiedBevelCut } from '../../../../library/layout-geometry/truss-envelopes/calculation/stage3';

export const TrussEnvelopeBevelCutTypeSelect = (props: {
  name: string;
  disabled?: boolean;

  bevelCut: TrussEnvelopeBevelCut | IndeterminateValue | null | undefined;
  submit: (bevelCut: UserSpecifiedBevelCut) => void;
}) => {
  const updateAngle = (angle: number | undefined) => {
    // The angle field is disabled / not rendered in these cases, so this is just a sanity check.
    if (!props.bevelCut || isIndeterminate(props.bevelCut)) return;

    props.submit({ ...props.bevelCut, angle });
  };
  const resetAngle = () => updateAngle(undefined);

  return (
    <Stack direction="row" spacing={1}>
      <PropertySelectField<TrussEnvelopeBevelCutType | 'None'>
        property={props.name}
        disabled={props.disabled}
        allowUnknownValues={isIndeterminate(props.bevelCut)}
        value={isIndeterminate(props.bevelCut) ? props.bevelCut : (props.bevelCut?.type ?? 'None')}
        options={['Front', 'Double', 'Back', 'None']}
        submit={(type) => props.submit(type === 'None' ? null : { type })}
      />

      {isIndeterminate(props.bevelCut) ? (
        <MaterialPropertyValuePair property="Angle" value={INDETERMINATE} />
      ) : (
        <AngleField
          label="Angle"
          value={props.bevelCut?.angle ?? 0}
          numberOfDecimals={1}
          min={1}
          max={89}
          onSubmit={updateAngle}
          disabled={!props.bevelCut || props.disabled}
          disableSwitchingDisplayFormat
          endAdornment={
            <TooltipIconButton
              title="Recalculate Angle"
              disabled={!props.bevelCut || props.disabled}
              onClick={resetAngle}
            >
              <ResetIcon />
            </TooltipIconButton>
          }
        />
      )}
    </Stack>
  );
};
